import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, ScanLine, FileText, User, Settings, LogOut } from 'lucide-react';
interface SidebarProps {
  onLogoutClick: () => void;
}
export function Sidebar({
  onLogoutClick
}: SidebarProps) {
  const navItems = [{
    icon: LayoutDashboard,
    label: 'Dashboard',
    path: '/'
  }, {
    icon: FileText,
    label: 'Reports',
    path: '/reports'
  }, {
    icon: User,
    label: 'Profile',
    path: '/profile'
  }];
  return <aside className="w-20 bg-gray-900 border-r border-gray-800 flex flex-col items-center py-6 fixed left-0 top-0 bottom-0 z-20" data-id="element-344">
      <div className="mb-8" data-id="element-345">
        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-346">
          <ScanLine className="w-6 h-6 text-white" data-id="element-347" />
        </div>
      </div>

      <nav className="flex-1 flex flex-col gap-6 w-full px-2" data-id="element-348">
        {navItems.map(item => <NavLink key={item.label} to={item.path} className={({
        isActive
      }) => `w-full aspect-square flex flex-col items-center justify-center rounded-xl transition-colors ${isActive ? 'bg-blue-600/20 text-blue-400 border border-blue-600/50' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'}`} title={item.label} data-id="element-349">
            <item.icon className="w-6 h-6" data-id="element-350" />
            <span className="text-[10px] mt-1 font-medium" data-id="element-351">{item.label}</span>
          </NavLink>)}
      </nav>

      <div className="mt-auto flex flex-col gap-6 w-full px-2" data-id="element-352">
        <NavLink to="/settings" className={({
        isActive
      }) => `w-full aspect-square flex flex-col items-center justify-center rounded-xl transition-colors ${isActive ? 'bg-blue-600/20 text-blue-400 border border-blue-600/50' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'}`} title="Settings" data-id="element-353">
          <Settings className="w-6 h-6" data-id="element-354" />
        </NavLink>
        <button onClick={onLogoutClick} className="w-full aspect-square flex flex-col items-center justify-center rounded-xl text-gray-400 hover:bg-gray-800 hover:text-gray-200 transition-colors" title="Logout" data-id="element-355">
          <LogOut className="w-6 h-6" data-id="element-356" />
        </button>
      </div>
    </aside>;
}